import { FC } from 'react';

import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { CrashTrafficLightConnected } from '../../../../components/trafficLight';
import { WinResultConnected } from '../../../../components/winResult/WinResultConnected';
import { useHighflyerStateSlice } from '../../../../store/slices/highflyerState/selectors';
import { MultiplierCellConnected } from '../multiplierCell';

import styles from './StatusBarCellConnected.module.css';

export const StatusBarCellConnected: FC = () => {
  const mul = useHighflyerStateSlice.getMultiplier();
  const currentStatus = useGameStateSlice.getCurrentStatus();
  const isMultiplier = useHighflyerStateSlice.getMultiplier();
  const waitMods = useModifiers(styles, 'statusBarContent', {
    showBottom: mul,
  });

  return (
    <div className={styles.statusBarCellContainer}>
      <div className={styles.statusBarContentWrapper}>
        {currentStatus != GameStatus.WaitForNextGame && currentStatus != GameStatus.Result && !isMultiplier && (
          <div className={styles.brandingImg}></div>
        )}
        <div className={`${styles.statusBarContent} ${waitMods}`}>
          <CrashTrafficLightConnected />
        </div>
        {mul && <MultiplierCellConnected />}
      </div>
      <div className={styles.winResultContainer}>
        <WinResultConnected />
      </div>
    </div>
  );
};
